import type { ConvexReactClient } from 'convex/react';

// Self-hosted: no opt-ins required
export async function fetchOptIns(_convex: ConvexReactClient): Promise<
  | { kind: 'loaded'; optIns: [] }
  | { kind: 'error'; error: string }
  | { kind: 'missingAuth' }
> {
  return { kind: 'loaded', optIns: [] };
}
